<script>
    import { fade } from "svelte/transition";

    import {
        getMbsItemNumLabel,
        updateProcedureItems,
    } from "../../../helpers/mbsHelper.svelte";

    import CodeSelectorManualMbsProceduresSelector from "./CodeSelectorManualMBSProceduresSelector.svelte";
    import { showInfo } from "../../../../../Utils/utilFunctions.svelte";

    export let itemProps = {},
        defaultItems = [],
        selectedItems = [],
        holidaysInState = [],
        updateItems = () => {},
        openNotification = () => {};

    $: isCardiacEncounter = itemProps.billingType == 3;

    $: if (defaultItems.length) _syncDefaultItems();

    $: if (selectedItems.length) _syncAdditionalItemOptions();
    else additionalItemOptions = [];

    $: selectedItemCategory = selectedItems.length
        ? selectedItems.some(({ itemNum }) => categoryOne.includes(itemNum))
            ? 1
            : selectedItems.some(({ itemNum }) => categoryTwo.includes(itemNum))
              ? 2
              : 0
        : itemProps.billingType == 2
          ? itemProps.neuraxialType
          : 0;

    let itemOptions = [];

    let additionalItemOptions = [],
        displayOptionKeys = [];

    let isAllProceduresModalOpen = false;

    const __default_billType_zero__ = [
        { key: "22025-0", value: "Art line" },
        {
            key: itemProps.mbsItem22012UsedToday ? "22014-0" : "22012-0",
            value: "Art monitor",
        },
        { key: "22020-0", value: "CVC Line" },
        {
            key: itemProps.mbsItem22012UsedToday ? "22014-1" : "22012-1",
            value: "CVC monitor",
        },
        { key: "22041-0", value: "Proximal block" },
        { key: "22042-0", value: "Eye block" },
        { key: "22031-0", value: "Neuraxial analgesia (initial)" },
        { key: "22036-0", value: "Neuraxial analgesia (top-up)" },
        { key: "22007-0", value: "Fibreoptic intubation" },
        { key: "22008-0", value: "Lung isolation" },
        { key: "22002-0", value: "Blood Transfusion" },
        // { key: "13703-0", value: "Blood collection" },
        { key: "22052-0", value: "Blood Transfusion for INH" },
    ];

    const __default_billType_one__ = [
        { key: "18222-0", value: "Regional top up < 15m" },
        { key: "13815-0", value: "CVC" },
        { key: "18225-0", value: "Regional top up > 15m" },
        { key: "13706-0", value: "Cannulation & Transfusion" },
        { key: "13857-0", value: "Airway access" },
        { key: "13842-0", value: "Art line" },
    ];

    const __default_billType_two__ = [
        { key: 1, value: "Insertion" },
        { key: 2, value: "Top up | Revision" },
    ];

    const __default_billType_Cardiac__ = [
        { key: "22051-0", value: "TOE: cardiac" },
        { key: "22054-0", value: "TOE: valves" },
        { key: "22025-0", value: "Art line" },
        {
            key: itemProps.mbsItem22012UsedToday ? "22014-0" : "22012-0",
            value: "Art monitor",
        },
        { key: "22020-0", value: "CVC Line" },
        {
            key: itemProps.mbsItem22012UsedToday ? "22014-1" : "22012-1",
            value: "CVC monitor",
        },
        { key: "22015-0", value: "PAC" },
        {
            key: itemProps.mbsItem22012UsedToday ? "22014-2" : "22012-2",
            value: "PAC monitor",
        },
        { key: "22031-0", value: "Neuraxial analgesia (initial)" },
        { key: "22007-0", value: "Fibreoptic intubation" },
        { key: "22008-0", value: "Lung isolation" },
        { key: "22002-0", value: "Blood transfusion" },
        { key: "22052-0", value: "Blood Transfusion for INH" },
    ];

    const categoryOne = [18216, 18219, 18226, 18227];
    const categoryTwo = [18222, 18225];

    export const handleSelectItem = (item, isFromQuickWin = true) => {
        const { billingType } = itemProps;
        const needUpdateNeuraxialType = billingType == 2;

        if (isFromQuickWin) {
            if (needUpdateNeuraxialType) {
                itemProps.neuraxialType = itemProps.neuraxialType
                    ? itemProps.neuraxialType == item?.key
                        ? 0
                        : (item.key ?? 0)
                    : (item.key ?? 0);
            }
        }

        //when neuraxial Top Up | Revision is selected, remove 17680 is already selected
        if(item.key && item.key == 2){
            if(selectedItems.some((c) => c.itemNum == 17680)) {
                selectedItems = selectedItems.filter((c) => c.itemNum != 17680);
                showInfo("17680 cannot be used for Top Up | Revision. Please select a Referred consult code.");
            }
        }

        updateItems(
            updateProcedureItems(
                item,
                selectedItems,
                itemProps,
                defaultItems,
                holidaysInState,
                false,
                openNotification,
            ),
        );
    };

    // HELPER FUNCTIONS
    const _syncDefaultItems = () => {
        itemOptions = [];

        const { billingType } = itemProps;

        if (billingType != 2) {
            const mapArr =
                billingType == 0
                    ? __default_billType_zero__
                    : billingType == 1
                      ? __default_billType_one__
                      : billingType == 3
                        ? __default_billType_Cardiac__
                        : [];

            mapArr.map((item) => {
                const { key, value } = item;

                const targetItem = defaultItems.find((dItem) => {
                    const combinedKey = `${dItem.itemNum}-${dItem.subItemNum}`;

                    return key == combinedKey;
                });

                if (targetItem)
                    itemOptions.push({
                        ...targetItem,
                        combinedKey: key,
                        value,
                    });
                else itemOptions.push({ value: "" });
            });
        } else itemOptions = [...__default_billType_two__];
    };

    const _syncAdditionalItemOptions = () => {
        // NOW consider billingType 0 & 1
        // billingType 2 does NOT support select other additional items exclude INSERTION and TOP-UP
        // billingType 3 NOT implemented yet
        const { billingType } = itemProps;

        additionalItemOptions = [];

        if (!displayOptionKeys.length) {
            if (billingType == 0)
                __default_billType_zero__.map((opt) =>
                    displayOptionKeys.push(opt.key),
                );
            else if (billingType == 1)
                __default_billType_one__.map((opt) =>
                    displayOptionKeys.push(opt.key),
                );
            else if (billingType == 3)
                __default_billType_Cardiac__.map((opt) =>
                    displayOptionKeys.push(opt.key),
                );
        }

        const selectedAPItems = selectedItems
            .filter((item) => item.infoType == "AdditionalProcedures")
            .map((item) => ({
                ...item,
                key: `${item.itemNum}-${item.subItemNum}`,
            }));

        if (!selectedAPItems.length) return;

        selectedAPItems.map((item) => {
            if (!displayOptionKeys.includes(item.key))
                additionalItemOptions.push(item);
            else
                additionalItemOptions = additionalItemOptions.filter(
                    (itm) => itm.key != item.key,
                );
        });
    };

    const _openAllProcedureModal = () => (isAllProceduresModalOpen = true);

    const _closeAllProcedureModal = () => (isAllProceduresModalOpen = false);

    const _getLabelFromCombinedKey = (combinedKey) => {
        if (!combinedKey) return "";

        const [itemNum, subItemNum] = combinedKey.split("-");

        return getMbsItemNumLabel({ itemNum, subItemNum });
    };
</script>

<div
    class="flex flex-col gap-y-2 border-2 rounded-md justify-center p-4"
    transition:fade={{ duration: isCardiacEncounter ? 100 : 0 }}
>
    <div class="flex flex-1 items-center justify-between">
        <p class="font-bold text-lg">Additional Procedures</p>

        {#if itemProps.billingType != 2}
            <button
                class="btn btn-sm btn-secondary"
                on:click|preventDefault={_openAllProcedureModal}
            >
                View all
            </button>
        {/if}
    </div>
    {#if itemOptions.length}
        <div class="grid grid-cols-2 w-full gap-4">
            {#each itemOptions as item}
                {#if item.value}
                    <button
                        class={`btn btn-sm rounded rounded-full hover:btn-primary text-xs ${
                            itemProps.billingType == 2
                                ? itemProps.neuraxialType == 3
                                    ? "btn-primary"
                                    : itemProps.neuraxialType == item.key
                                      ? "btn-primary"
                                      : "btn-secondary"
                                : selectedItems.some(
                                        (itm) =>
                                            itm.itemNum == item.itemNum &&
                                            itm.subItemNum == item.subItemNum,
                                    )
                                  ? "btn-primary"
                                  : "btn-secondary"
                        }`}
                        on:click|preventDefault={() => handleSelectItem(item)}
                    >
                        {itemProps.billingType == 2
                            ? ""
                            : `${_getLabelFromCombinedKey(item.combinedKey)}`}
                        {item.value}
                    </button>
                {:else}
                    <div />
                {/if}
            {/each}
        </div>
        <div class="divider" style="margin-top: 0px; margin-bottom: 0px;"></div>
    {/if}
    <div class="grid grid-cols-2 w-full gap-4">
        {#each additionalItemOptions as item}
            <button
                class={`btn btn-sm rounded rounded-full hover:btn-primary text-xs ${
                    selectedItems.some(
                        (itm) =>
                            itm.itemNum == item.itemNum &&
                            itm.subItemNum == item.subItemNum,
                    )
                        ? "btn-primary"
                        : "btn-secondary"
                }`}
                on:click|preventDefault={() => handleSelectItem(item, false)}
            >
                {getMbsItemNumLabel(item)}
                {item.infoShortTitle}
            </button>
        {/each}
    </div>
</div>

<CodeSelectorManualMbsProceduresSelector
    isModalOpen={isAllProceduresModalOpen}
    {defaultItems}
    {selectedItems}
    addItem={handleSelectItem}
    closeModal={_closeAllProcedureModal}
/>
